export { generateDataAttr } from './generateDataAttr';
